import {RootStore} from "stores/rootStore";
import {makeAutoObservable} from "mobx";
import {pushWorkspaceEntry} from "workspaceHistory";

export type Tab = "scan" | "plan" | "history";
/** The scan page's top-level folder: the scan tabs or the Humanizer. */
export type Workspace = "scan" | "humanizer";

export class LayoutStore {
    root: RootStore

    tab: Tab = "scan"
    isMobile = false;
    isSidebarOpen = false
    isProfileOpen = false
    isScanOptionsOpen = false;
    workspace: Workspace = "scan";

    constructor(root: RootStore) {
        this.root = root
        makeAutoObservable(this, {});
    }

    setScanOptionsOpen(open: boolean) {
        this.isScanOptionsOpen = open
    }

    setDeviceType(device: "mobile" | "desktop") {
        this.isMobile = device === "mobile"
    }

    setSidebarOpen(open: boolean) {
        this.isSidebarOpen = open
    }

    setProfileOpen(open: boolean) {
        this.isProfileOpen = open
    }

    setTab(tab: Tab) {
        this.tab = tab
    }

    /** `back`: leave a history entry behind, so the browser's Back returns to the
     *  workspace being left (the popstate side is `useWorkspaceInHistory`). */
    setWorkspace(workspace: Workspace, {back = false} = {}) {
        // The URL's override lasts while the folder is open (the URL then carries it).
        if (workspace !== 'humanizer') this.root.user.forceHumanizer(false)
        if (workspace === this.workspace) return
        // A Restore still loading would switch the folder back when it lands.
        this.root.history.cancelRestore()
        if (back) pushWorkspaceEntry(this.workspace, workspace)
        this.workspace = workspace
        this.root.humanizer.syncDraft(workspace)
    }

    /** The Humanizer folder is open — never while the Humanizer is unavailable
     *  to this user (a stale workspace value, the widget's runtime override, an
     *  account whose role is not offered it), whatever was set. */
    get humanizerOpen(): boolean {
        return this.workspace === 'humanizer' && this.root.user.humanizerAvailable
    }
}